import React from 'react';

import { useBulkDeployModalContext, BULK_DEPLOY_MODALS } from 'ion-experimental/app/bulk-deploy/BulkDeployModalContext';

import BulkDeployDiffContent from './BulkDeployDiffContent';
import BulkDeployDiffActions from './BulkDeployDiffActions';

const EMPTY_STATE_PROPS = {
  DialogProps: {
    open: false,
    onClose: () => {},
    maxWidth: 'lg',
    fullWidth: true,
  },
  title: '',
  content: null,
  actions: null,
};

export default function useBaseDialogProps() {
  const {
    activeModal,
    name: pipelineName,
    id: pipelineId,
    writeKey: writekey,
    cluster,
    integrations,
    onCloseModal,
  } = useBulkDeployModalContext();

  const isOpen = activeModal === BULK_DEPLOY_MODALS.PIPELINE_DIFF;

  if (!isOpen && !pipelineId) {
    return EMPTY_STATE_PROPS;
  }

  return {
    DialogProps: {
      open: activeModal === BULK_DEPLOY_MODALS.PIPELINE_DIFF,
      onClose: onCloseModal,
      maxWidth: 'lg',
      fullWidth: true,
    },
    title: `${pipelineName} integration changes`,
    content: (
      <BulkDeployDiffContent
        pipelineId={pipelineId}
        writekey={writekey}
        clusterId={cluster.id}
        integrations={integrations}
      />
    ),
    actions: <BulkDeployDiffActions onClose={onCloseModal} />,
  };
}
